<template>
  <div class="main-layout">
    <Navigation />
    <StatsSidebar v-if="showStatsSidebar" ref="statsSidebarRef" />
    
  
    <main class="main-content" :class="{ 'no-sidebar': !showStatsSidebar }">
      <slot></slot>
    </main>

    
    <Footer />
    <FeedbackButton />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Navigation from './Navigation.vue'
import StatsSidebar from './StatsSidebar.vue'
import Footer from './Footer.vue'
import FeedbackButton from './FeedbackButton.vue'

@Options({
  components: {
    Navigation,
    StatsSidebar,
    Footer,
    FeedbackButton
  },
  props: {
    showStatsSidebar: {
      type: Boolean,
      default: true
    }
  }
})
export default class MainLayout extends Vue {
  showStatsSidebar!: boolean;

  mounted() {
    console.log('MainLayout: Footer component imported:', Footer)
  }

  refreshStats() {
    // @ts-ignore
    this.$refs.statsSidebarRef?.refresh()
  }
}
</script>

<style scoped>
.main-layout {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: #1a1a1a;
  line-height: 1.5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  padding: 0;
}

.main-content {
  padding-right: 300px; /* Account for stats sidebar */
  padding-top: 80px; /* Account for fixed navigation */
  padding-bottom: 2rem; /* Add space before footer */
  flex: 1;
  min-height: calc(100vh - 80px - 120px); /* Account for nav and footer */
}

.main-content.no-sidebar {
  padding-right: 2rem; /* Remove sidebar padding when sidebar is hidden */
}

@media (max-width: 1024px) {
  .main-content {
    padding-right: 0;
  }
}
</style> 